// extracted by mini-css-extract-plugin
export var active = "TagPage-module--active--2148e";
export var item = "TagPage-module--item--71e1b";
export var options = "TagPage-module--options--aa35e";
export var optionsBtn = "TagPage-module--options-btn--d978a";
export var optionsLabel = "TagPage-module--options-label--7add3";
export var optionsLabelOrder = "TagPage-module--options-label-order--fa51d";
export var optionsLabelView = "TagPage-module--options-label-view--863a7";
export var optionsType = "TagPage-module--options-type--9f094";
export var optionsTypeButtons = "TagPage-module--options-type-buttons--6fcbc";
export var optionsTypeOrder = "TagPage-module--options-type-order--3a2c3";
export var optionsTypeView = "TagPage-module--options-type-view--a0826";
export var outer = "TagPage-module--outer--d4161";